<div class="content" [style.background-image]="thumbnailUrl | safeBackgroundImageUrl" [class.selected]="option?.IsSelected" (click)="handleOptionSelect()">
    <div class="checkmark">
        <icon name="success"></icon>
    </div>
</div>
<div class="label">{{option.Name}}</div>